type RadioUnselectedProps = {
    onClick?: () => void;
    size?: number;
};

const RadioUnselected = ({ onClick, size = 24 }: RadioUnselectedProps) => {
    return (
        <button
            type='button'
            onClick={onClick}
            className='flex items-center justify-center'
            style={{ width: size, height: size }}
        >
            <svg
                width={size}
                height={size}
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <circle
                    cx='12'
                    cy='12'
                    r='11.25'
                    fill='white'
                    stroke='#3A4146'
                    strokeWidth='1.5'
                />
            </svg>
        </button>
    );
};

export default RadioUnselected;
